module.exports = __webpack_public_path__ + "img/commodityclose.13dd7d73.png";